import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../api/authService';
import { useSecretoDeUrl } from '../hooks/useSecretoDeUrl';
import { Button, Alert } from '@/shared/components/ui';

export const ActivarCuentaForm = () => {
    // El código se lee una vez (fragmento, ruta o query) y la URL se limpia: el efecto depende del estado, no de la URL.
    const codigo = useSecretoDeUrl('codigo');
    const enviado = useRef(false);
    const navigate = useNavigate();

    const [estado, setEstado] = useState<'procesando' | 'exito' | 'error'>('procesando');
    const [mensaje, setMensaje] = useState('Activando tu cuenta...');
    const [countdown, setCountdown] = useState(5);

    useEffect(() => {
        if (!codigo) {
            setEstado('error');
            setMensaje('Código de activación inválido o no proporcionado');
            return;
        }

        // Una sola activación por montaje: con StrictMode el efecto correría dos veces y el segundo POST daría «ya utilizado».
        if (enviado.current) return;
        enviado.current = true;

        // Activar cuenta
        authService.activarCuenta(codigo)
            .then(() => {
                setEstado('exito');
                setMensaje('¡Tu cuenta ha sido activada exitosamente!');
            })
            .catch((error) => {
                setEstado('error');
                setMensaje(
                    error.response?.data?.message ||
                    'Error al activar la cuenta. El código puede ser inválido o haber expirado.'
                );
            });
    }, [codigo]);

    // Countdown solo cuando es éxito
    useEffect(() => {
        if (estado === 'exito' && countdown > 0) {
            const timer = setTimeout(() => {
                setCountdown(countdown - 1);
            }, 1000);
            return () => clearTimeout(timer);
        }

        if (estado === 'exito' && countdown === 0) {
            navigate('/login');
        }
    }, [estado, countdown, navigate]);

    const handleIrAlLogin = () => {
        navigate('/login');
    };

    // Estado: Procesando
    if (estado === 'procesando') {
        return (
            <div className="login-form form-centered">
                <div className="loading-spinner" />
                <p className="countdown-text">{mensaje}</p>
            </div>
        );
    }

    // Estado: Error
    if (estado === 'error') {
        return (
            <form className="login-form form-centered">
                <Alert type="error">{mensaje}</Alert>
                <Button
                    type="button"
                    onClick={handleIrAlLogin}
                    variant="primary"
                    fullWidth
                    className="login-btn"
                >
                    Volver al Login
                </Button>
            </form>
        );
    }

    // Estado: Éxito
    return (
        <form className="login-form form-centered">
            <Alert type="success">
                <p>{mensaje}</p>
                <p className="countdown-text">
                    Serás redirigido al login en <strong className="countdown-number">{countdown}</strong> segundos
                </p>
            </Alert>
            <Button
                type="button"
                onClick={handleIrAlLogin}
                variant="primary"
                fullWidth
                className="login-btn"
            >
                Ir al Login Ahora
            </Button>
        </form>
    );
};
